module.exports = __webpack_public_path__ + "img/men_young.ae09bd25.png";